<template>
  <div>
    <!-- <hero-banner :title="title"></hero-banner> -->
      <nav class="d-none d-md-block " aria-label="breadcrumb" >
            <ol class="breadcrumb breadcrumb-arrow">
                <li class="breadcrumb-item">
                <router-link to="/" style="color:#666666">Home</router-link>
              </li>
              
                <li class="breadcrumb-item active">{{title}}</li>
            </ol>
        </nav>

    <div class="my-5 container">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="terms-list">
            <div class="mb-5">
              <div class="block">
  <el-timeline>
    <el-timeline-item timestamp="1996" placement="top">
      <el-card>
        <!-- <h>Update Github template</h4> -->
        <p>Appointed as the authorized distributors of Mercedes-Benz vehicles in Ghana.</p>
      </el-card>
    </el-timeline-item>
    <el-timeline-item timestamp="1997" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>The Mercedes-Benz showroom and Service Centre were opened on Graphic Road in Accra.</p>
      </el-card>
    </el-timeline-item>
    <el-timeline-item timestamp="2003" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>Completed our ultra-modern service center in Tema.  New facility caters for Passenger Cars, Accident Repairs and Body & Paint works. </p>
      </el-card>
    </el-timeline-item>
      <el-timeline-item timestamp="2008" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>Relocated the Mercedes-Benz showroom and Head offices to the iconic Silver Star Towers at Airport City.  </p>
      </el-card>
    </el-timeline-item>
     <el-timeline-item timestamp="2015" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>Created an administration office and showroom in Tema.
Relocated the Mercedes-Benz Commercial Vehicles sales department and showroom to Tema.
  </p>
      </el-card>
    </el-timeline-item>
     <el-timeline-item timestamp="2016" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>Acquired distributorship of Suzuki vehicles in Ghana.
Opened the Kumasi branch.

  </p>
      </el-card>
    </el-timeline-item>
     <el-timeline-item timestamp="2017" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>Relocated the head office to Graphic Road and refurbished our Sales and After-Sales facilities.
  </p>
      </el-card>
    </el-timeline-item>
     <el-timeline-item timestamp="2019" placement="top">
      <el-card>
        <!-- <h4>Update Github template</h4> -->
        <p>Ended our partnership with the Suzuki brand.
Acquired the exclusive distributorship of Peugeot and Citroën brands in Ghana.

  </p>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</div>


             
            </div>
           
             

          </div>
        </div>
      </div>
    </div>
      <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>

<script>
// import TopHeroBanner from "@/components/TopHeroBanner1.vue";
import CoreValues from "../components/Core.vue";
export default {
  components: {  core: CoreValues },
  name: "milestone",
  data() {
    return {
      title: "Milestones",
     
    };
  },
  metaInfo() {
    return {
      title: "Milestones"
    };
  }
};
</script>
